import * as types from "../actions/index";
export default function(state = null, action) {
  switch (action.type) {
    case types.SESSION_CONTEXT:
      return action.payload;
    case types.CLEAR_SESSION_CONTEXT:
      return action.payload;
    // no default
  }
  return state;
}
